// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SeoRouteImport } from './routes/seo'
import { Route as SaisineRouteImport } from './routes/saisine'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PolitiqueCookiesRouteImport } from './routes/politique-cookies'
import { Route as PhaseProRouteImport } from './routes/phase-pro'
import { Route as MentionsLegalesRouteImport } from './routes/mentions-legales'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LegalRouteImport } from './routes/legal'
import { Route as FoyerRouteImport } from './routes/foyer'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as EmailConfirmationRouteImport } from './routes/email-confirmation'
import { Route as ConfidentialiteRouteImport } from './routes/confidentialite'
import { Route as CompteRouteImport } from './routes/compte'
import { Route as CommentCaMarcheRouteImport } from './routes/comment-ca-marche'
import { Route as CgvRouteImport } from './routes/cgv'
import { Route as ArchivesRouteImport } from './routes/archives'
import { Route as AntichambreRouteImport } from './routes/antichambre'
import { Route as IndexRouteImport } from './routes/index'
import { Route as VerdictIdRouteImport } from './routes/verdict.$id'
import { Route as VIdRouteImport } from './routes/v.$id'
import { Route as PostVerdictIdRouteImport } from './routes/post-verdict.$id'
import { Route as MemoIdRouteImport } from './routes/memo.$id'
import { Route as ExpertsCatalogueRouteImport } from './routes/experts.catalogue'
import { Route as ExpertsSlugRouteImport } from './routes/experts.$slug'
import { Route as DeliberationIdRouteImport } from './routes/deliberation.$id'
import { Route as DashboardIdRouteImport } from './routes/dashboard.$id'
import { Route as ChatNumRouteImport } from './routes/chat.$num'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as CompteProfilRouteImport } from './routes/compte.profil'
import { Route as CompteParametresRouteImport } from './routes/compte.parametres'
import { Route as CompteFacturationRouteImport } from './routes/compte.facturation'
import { Route as MemoIdFeedbackRouteImport } from './routes/memo.$id.feedback'

const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const SeoRoute = SeoRouteImport.update({
            id: '/seo',path: '/seo',getParentRoute: () => rootRouteImport
          })
const SaisineRoute = SaisineRouteImport.update({
            id: '/saisine',path: '/saisine',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PolitiqueCookiesRoute = PolitiqueCookiesRouteImport.update({
            id: '/politique-cookies',path: '/politique-cookies',getParentRoute: () => rootRouteImport
          })
const PhaseProRoute = PhaseProRouteImport.update({
            id: '/phase-pro',path: '/phase-pro',getParentRoute: () => rootRouteImport
          })
const MentionsLegalesRoute = MentionsLegalesRouteImport.update({
            id: '/mentions-legales',path: '/mentions-legales',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const LegalRoute = LegalRouteImport.update({
            id: '/legal',path: '/legal',getParentRoute: () => rootRouteImport
          })
const FoyerRoute = FoyerRouteImport.update({
            id: '/foyer',path: '/foyer',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const EmailConfirmationRoute = EmailConfirmationRouteImport.update({
            id: '/email-confirmation',path: '/email-confirmation',getParentRoute: () => rootRouteImport
          })
const ConfidentialiteRoute = ConfidentialiteRouteImport.update({
            id: '/confidentialite',path: '/confidentialite',getParentRoute: () => rootRouteImport
          })
const CompteRoute = CompteRouteImport.update({
            id: '/compte',path: '/compte',getParentRoute: () => rootRouteImport
          })
const CommentCaMarcheRoute = CommentCaMarcheRouteImport.update({
            id: '/comment-ca-marche',path: '/comment-ca-marche',getParentRoute: () => rootRouteImport
          })
const CgvRoute = CgvRouteImport.update({
            id: '/cgv',path: '/cgv',getParentRoute: () => rootRouteImport
          })
const ArchivesRoute = ArchivesRouteImport.update({
            id: '/archives',path: '/archives',getParentRoute: () => rootRouteImport
          })
const AntichambreRoute = AntichambreRouteImport.update({
            id: '/antichambre',path: '/antichambre',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const VerdictIdRoute = VerdictIdRouteImport.update({
            id: '/verdict/$id',path: '/verdict/$id',getParentRoute: () => rootRouteImport
          })
const VIdRoute = VIdRouteImport.update({
            id: '/v/$id',path: '/v/$id',getParentRoute: () => rootRouteImport
          })
const PostVerdictIdRoute = PostVerdictIdRouteImport.update({
            id: '/post-verdict/$id',path: '/post-verdict/$id',getParentRoute: () => rootRouteImport
          })
const MemoIdRoute = MemoIdRouteImport.update({
            id: '/memo/$id',path: '/memo/$id',getParentRoute: () => rootRouteImport
          })
const ExpertsCatalogueRoute = ExpertsCatalogueRouteImport.update({
            id: '/experts/catalogue',path: '/experts/catalogue',getParentRoute: () => rootRouteImport
          })
const ExpertsSlugRoute = ExpertsSlugRouteImport.update({
            id: '/experts/$slug',path: '/experts/$slug',getParentRoute: () => rootRouteImport
          })
const DeliberationIdRoute = DeliberationIdRouteImport.update({
            id: '/deliberation/$id',path: '/deliberation/$id',getParentRoute: () => rootRouteImport
          })
const DashboardIdRoute = DashboardIdRouteImport.update({
            id: '/dashboard/$id',path: '/dashboard/$id',getParentRoute: () => rootRouteImport
          })
const ChatNumRoute = ChatNumRouteImport.update({
            id: '/chat/$num',path: '/chat/$num',getParentRoute: () => rootRouteImport
          })
const AuthCallbackRoute = AuthCallbackRouteImport.update({
            id: '/auth/callback',path: '/auth/callback',getParentRoute: () => rootRouteImport
          })
const CompteProfilRoute = CompteProfilRouteImport.update({
            id: '/profil',path: '/profil',getParentRoute: () => CompteRoute
          })
const CompteParametresRoute = CompteParametresRouteImport.update({
            id: '/parametres',path: '/parametres',getParentRoute: () => CompteRoute
          })
const CompteFacturationRoute = CompteFacturationRouteImport.update({
            id: '/facturation',path: '/facturation',getParentRoute: () => CompteRoute
          })
const MemoIdFeedbackRoute = MemoIdFeedbackRouteImport.update({
            id: '/feedback',path: '/feedback',getParentRoute: () => MemoIdRoute
          })





const CompteRouteChildren = {
  CompteFacturationRoute: CompteFacturationRoute,CompteParametresRoute: CompteParametresRoute,CompteProfilRoute: CompteProfilRoute
}

const CompteRouteWithChildren = CompteRoute._addFileChildren(CompteRouteChildren)




const MemoIdRouteChildren = {
  MemoIdFeedbackRoute: MemoIdFeedbackRoute
}

const MemoIdRouteWithChildren = MemoIdRoute._addFileChildren(MemoIdRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AntichambreRoute: AntichambreRoute,ArchivesRoute: ArchivesRoute,CgvRoute: CgvRoute,CommentCaMarcheRoute: CommentCaMarcheRoute,CompteRoute: CompteRouteWithChildren,ConfidentialiteRoute: ConfidentialiteRoute,EmailConfirmationRoute: EmailConfirmationRoute,ForgotPasswordRoute: ForgotPasswordRoute,FoyerRoute: FoyerRoute,LegalRoute: LegalRoute,LoginRoute: LoginRoute,MentionsLegalesRoute: MentionsLegalesRoute,PhaseProRoute: PhaseProRoute,PolitiqueCookiesRoute: PolitiqueCookiesRoute,PricingRoute: PricingRoute,ResetPasswordRoute: ResetPasswordRoute,SaisineRoute: SaisineRoute,SeoRoute: SeoRoute,SettingsRoute: SettingsRoute,SignupRoute: SignupRoute,AuthCallbackRoute: AuthCallbackRoute,ChatNumRoute: ChatNumRoute,DashboardIdRoute: DashboardIdRoute,DeliberationIdRoute: DeliberationIdRoute,ExpertsSlugRoute: ExpertsSlugRoute,ExpertsCatalogueRoute: ExpertsCatalogueRoute,MemoIdRoute: MemoIdRouteWithChildren,PostVerdictIdRoute: PostVerdictIdRoute,VIdRoute: VIdRoute,VerdictIdRoute: VerdictIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)